import React, { ComponentProps } from 'react'

import dynamic from 'next/dynamic'

// サーバー側でレンダリングされると checkbox 内のアイコンが大きく表示されてしまうため ssr: false を指定
const BaseCheckbox = dynamic(
  () => import('@style-port/roov-ui-components-react').then(module_ => module_.Checkbox),
  { ssr: false }
)

type Props = ComponentProps<typeof BaseCheckbox>

export function Checkbox(props: Props) {
  return <BaseCheckbox {...props} />
}
